import { QueryState } from '@common/types/queryState';
import { SortingState } from '@tanstack/react-table';
import { useCallback, useMemo } from 'react';

const STABLE_DEFAULT_SORT: SortingState[0] = { id: 'id', desc: false };

const normalizeSortingState = (sorts: SortingState): SortingState => {
    const filteredSorts = sorts.filter(
        (sort) => sort.id !== STABLE_DEFAULT_SORT.id,
    );

    return [...filteredSorts, STABLE_DEFAULT_SORT];
};

export const useSorting = (
    sorting: SortingState,
    setUrl: (update: Partial<QueryState>) => void,
) => {
    const onSortingChange = useCallback(
        (updater: SortingState | ((old: SortingState) => SortingState)) => {
            const next =
                typeof updater === 'function' ? updater(sorting) : updater;
            setUrl({ sorting: normalizeSortingState(next) });
        },
        [sorting, setUrl],
    );

    return useMemo(
        () => ({ onSortingChange, sorting }),
        [onSortingChange, sorting],
    );
};

export type UseSortingResult = ReturnType<typeof useSorting>;
